import * as React from "react";
import {ReadAndWriteBlackNavBar} from "../../../components/ReadAndWriteBlackNavBar";
import {ToolBar} from "../../components/ToolBar";
import {Display} from "../../../components/Display";
import {ReadAndWriteContext} from "../../../providers/ReadAndWriteProvider";
import {PAGES} from "../../pages/MainContentPage";


export const TopBar: React.FC = () => {
    const {currentPage} = React.useContext(ReadAndWriteContext);
    const [showToolbar, setShowToolbar] = React.useState<boolean>(false);
    React.useEffect(() => {
        setShowToolbar([PAGES.UPDATING, PAGES.SETTINGS, PAGES.EDITING].includes(currentPage))
    }, [currentPage]);
    return (
        <>
            <ReadAndWriteBlackNavBar/>
            <Display isVisible={showToolbar}>
                <ToolBar/>
            </Display>
        </>
    );
};